"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_sdk_1 = __importDefault(require("aws-sdk"));
var axios_1 = __importDefault(require("axios"));
var RefreshableCredentials_1 = __importDefault(require("./RefreshableCredentials"));
var StudioApiAdaptor_1 = require("./StudioApiAdaptor");
var TurbosquidArtistAdaptor_1 = require("./TurbosquidArtistAdaptor");
var configWithToken = function (token) { return ({
    headers: __assign(__assign({}, (token ? { Authorization: "Bearer " + token } : {})), { 'Content-Type': 'application/json' }),
}); };
var Uploader = /** @class */ (function () {
    function Uploader(_a) {
        var _this = this;
        var endpoint = _a.endpoint, authToken = _a.authToken, csrfToken = _a.csrfToken, _b = _a.adapter, adapter = _b === void 0 ? StudioApiAdaptor_1.STUDIO_API_ADAPTER : _b;
        this.getCredentials = function () { return __awaiter(_this, void 0, void 0, function () {
            var fetchCredentials, credentials;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchCredentials = function () {
                            return axios_1.default
                                .post(_this.endpoint + "/credentials", 
                            // Send an empty json object to prevent issues with axios and empty POST bodies
                            _this.csrfToken ? TurbosquidArtistAdaptor_1.csrfTokenData(_this.csrfToken) : {}, configWithToken(_this.authToken))
                                .then(function (_a) {
                                var data = _a.data;
                                return _this.mapCredentials(data);
                            });
                        };
                        return [4 /*yield*/, fetchCredentials()];
                    case 1:
                        credentials = _a.sent();
                        aws_sdk_1.default.config.update({
                            region: credentials.region,
                            credentials: new RefreshableCredentials_1.default(credentials, fetchCredentials),
                        });
                        return [2 /*return*/, aws_sdk_1.default.config.credentials];
                }
            });
        }); };
        this.upload = function (file, onProgress, fileAttributes) {
            if (!aws_sdk_1.default.config.credentials) {
                throw new Error('AWS is not configured');
            }
            var key = "" + aws_sdk_1.default.config.credentials.keyPrefix + Date.now() + "/" + file.name;
            var managedUpload = _this.uploadToS3(key, file, onProgress);
            var process = managedUpload.promise()
                .then(function () { return _this.processFile(key, fileAttributes); });
            return {
                managedUpload: managedUpload,
                process: process
            };
        };
        this.uploadToS3 = function (key, file, onProgress) {
            var credentials = aws_sdk_1.default.config.credentials;
            var s3 = new aws_sdk_1.default.S3({
                apiVersion: '2006-03-01',
                params: { Bucket: credentials.bucket },
                correctClockSkew: true,
            });
            var uploadOptions = {};
            if (credentials.durable) {
                uploadOptions.partSize = 1024 * 1024 * 5;
                uploadOptions.queueSize = 1;
                aws_sdk_1.default.config.httpOptions = __assign(__assign({}, aws_sdk_1.default.config.httpOptions), { timeout: 0 });
            }
            var upload = s3.upload({
                Key: key,
                Body: file,
                ACL: 'private',
                Bucket: credentials.bucket,
            }, uploadOptions);
            upload.on('httpUploadProgress', onProgress);
            return upload;
        };
        this.processFile = function (key, fileAttributes) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default
                            .post(this.endpoint + "/process", this.mapProcessData(key, fileAttributes), configWithToken(this.authToken))
                            .then(function (resp) { return _this.mapProcess(resp.data); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.handleRetry = function (response) {
            if (!aws_sdk_1.default.config.credentials) {
                throw new Error('AWS credentials not set');
            }
            var credentials = aws_sdk_1.default.config.credentials;
            if (response.error.name === 'RequestTimeTooSkewed') {
                credentials.serverSkewTime =
                    new Date().getTime() -
                        Date.parse(response.httpResponse.headers['date']);
                response.error.retryable = true;
            }
            else if (response.error.name === 'ExpiredToken') {
                credentials.expired = true;
                response.error.retryable = true;
            }
            else if (response.error.name === 'TimeoutError') {
                credentials.durable = true;
                aws_sdk_1.default.config.httpOptions = __assign(__assign({}, aws_sdk_1.default.config.httpOptions), { timeout: 0 });
                response.error.retryable = true;
            }
        };
        this.endpoint = endpoint;
        this.authToken = authToken;
        this.adapter = adapter;
        this.csrfToken = csrfToken;
        // TODO: investigate why no type is available for AWS.events
        aws_sdk_1.default.events.on('retry', function (r) {
            return _this.handleRetry(r);
        });
    }
    Uploader.prototype.mapProcessData = function (key, fileAttributes) {
        switch (this.adapter) {
            case StudioApiAdaptor_1.STUDIO_API_ADAPTER:
                return StudioApiAdaptor_1.mapStudioApiProcessData(key);
            case TurbosquidArtistAdaptor_1.TURBOSQUID_API_ADAPTER:
                if (!this.csrfToken)
                    throw new Error('no csrf token');
                if (!fileAttributes)
                    throw new Error('no file attributes');
                return TurbosquidArtistAdaptor_1.mapTurbosquidApiProcessData(key, fileAttributes, this.csrfToken);
            default:
                throw new Error('invalid adaptor');
        }
    };
    Uploader.prototype.mapProcess = function (resp) {
        switch (this.adapter) {
            case StudioApiAdaptor_1.STUDIO_API_ADAPTER:
                return resp.data;
            case TurbosquidArtistAdaptor_1.TURBOSQUID_API_ADAPTER:
                return TurbosquidArtistAdaptor_1.mapProcess(resp);
            default:
                throw new Error('invalid adaptor');
        }
    };
    Uploader.prototype.mapCredentials = function (data) {
        switch (this.adapter) {
            case StudioApiAdaptor_1.STUDIO_API_ADAPTER:
                return StudioApiAdaptor_1.mapCredentials(data);
            case TurbosquidArtistAdaptor_1.TURBOSQUID_API_ADAPTER:
                return TurbosquidArtistAdaptor_1.mapCredentials(data);
            default:
                throw new Error('invalid adaptor');
        }
    };
    Uploader.getProgress = function (upload) {
        switch (upload.status) {
            case 'pending':
                return Math.ceil((upload.loaded / upload.total) * 100);
            case 'processing':
            case 'saving':
            case 'success':
            case 'failed':
            case 'queued':
                return 100;
            default:
                return 0;
        }
    };
    return Uploader;
}());
exports.default = Uploader;
//# sourceMappingURL=Uploader.js.map